import { useParams } from "react-router-dom";
import EntityProfile from "../../views/Client/EntityProfile";

const ViewClientPage = () => {
  const { id } = useParams();
  return <EntityProfile clientId={id} />;
};

export default ViewClientPage;
